"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleEligibilityChecker = void 0;
var types_1 = require("../types");
/**
 * The `CollectibleEligibilityChecker` monitors the sale phase and keeps the eligibility state
 * in sync if the currently connected address is subscribed.
 */
var CollectibleEligibilityChecker = /** @class */ (function () {
    function CollectibleEligibilityChecker(store, dataProviders, collectibleContract, fetchOAuth) {
        var _this = this;
        this.store = store;
        this.dataProviders = dataProviders;
        this.collectibleContract = collectibleContract;
        this.fetchOAuth = fetchOAuth;
        this.checkSaleEligibility = function () { return __awaiter(_this, void 0, void 0, function () {
            var presaleEligibility, isEligibleForPresale, claimEligibility, e_1, body, _e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldCheckPresaleEligiblity()) return [3 /*break*/, 5];
                        this.store.setState({
                            isFetchingPresaleEligibility: true,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this._fetchPresaleEligibility()];
                    case 2:
                        presaleEligibility = _a.sent();
                        isEligibleForPresale = Boolean(presaleEligibility === null || presaleEligibility === void 0 ? void 0 : presaleEligibility.presale);
                        this.store.setState({
                            presaleEligibility: {
                                isEligibleForPresale: isEligibleForPresale,
                                dynamicPresaleLimit: typeof (presaleEligibility === null || presaleEligibility === void 0 ? void 0 : presaleEligibility.presaleLimit) === 'string'
                                    ? parseInt(presaleEligibility.presaleLimit || '0')
                                    : presaleEligibility === null || presaleEligibility === void 0 ? void 0 : presaleEligibility.presaleLimit,
                                remainingAmount: isEligibleForPresale
                                    ? typeof presaleEligibility.remainingAmount === 'string'
                                        ? parseInt(presaleEligibility.remainingAmount || '0')
                                        : presaleEligibility.remainingAmount
                                    : undefined,
                            },
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.store.setState({
                            isFetchingPresaleEligibility: false,
                        });
                        return [7 /*endfinally*/];
                    case 4: return [3 /*break*/, 14];
                    case 5:
                        if (!this.shouldCheckClaimEligibility()) return [3 /*break*/, 14];
                        this.store.setState({
                            isFetchingClaimEligibility: true,
                        });
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, 13, 14]);
                        return [4 /*yield*/, this._fetchClaimEligibility()];
                    case 7:
                        claimEligibility = _a.sent();
                        this.store.setState({
                            claimEligibility: __assign(__assign({}, (claimEligibility || {})), { amount: typeof claimEligibility.amount === 'string'
                                    ? parseInt(claimEligibility.amount || '0')
                                    : claimEligibility.amount, remainingAmount: typeof claimEligibility.remainingAmount === 'string'
                                    ? parseInt(claimEligibility.remainingAmount || '0')
                                    : claimEligibility.remainingAmount }),
                        });
                        return [3 /*break*/, 14];
                    case 8:
                        e_1 = _a.sent();
                        if (!e_1.response) return [3 /*break*/, 12];
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, e_1.response.json()];
                    case 10:
                        body = _a.sent();
                        if (body.message === 'Too many tokens requested') {
                            this.store.setState({
                                // @ts-ignore
                                claimEligibility: {
                                    remainingAmount: 0,
                                },
                            });
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        _e_1 = _a.sent();
                        return [3 /*break*/, 12];
                    case 12: throw e_1;
                    case 13:
                        this.store.setState({
                            isFetchingClaimEligibility: false,
                        });
                        return [7 /*endfinally*/];
                    case 14: return [2 /*return*/];
                }
            });
        }); };
    }
    CollectibleEligibilityChecker.prototype.shouldCheckPresaleEligiblity = function () {
        var _a;
        return ([types_1.SalePhase.TO_PRESALE, types_1.SalePhase.PRESALE].includes(this.store.state.salePhase) &&
            !this.store.state.isFetchingPresaleEligibility &&
            Boolean((_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.selectedAddress()));
    };
    CollectibleEligibilityChecker.prototype.shouldCheckClaimEligibility = function () {
        var _a;
        return ([types_1.SalePhase.TO_CLAIM, types_1.SalePhase.CLAIM].includes(this.store.state.salePhase) &&
            !this.store.state.isFetchingClaimEligibility &&
            Boolean((_a = window.ManifoldEthereumProvider) === null || _a === void 0 ? void 0 : _a.selectedAddress()));
    };
    CollectibleEligibilityChecker.prototype._fetchPresaleEligibility = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchOAuth()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.dataProviders.collectibleServerAPI.getPresaleEligibilty(this.store.state.collectibleId)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleEligibilityChecker.prototype._fetchClaimEligibility = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataProviders.collectibleServerAPI.getClaimEligibility(this.store.state.collectibleId, window.ManifoldEthereumProvider.selectedAddress())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CollectibleEligibilityChecker;
}());
exports.CollectibleEligibilityChecker = CollectibleEligibilityChecker;
